import React, { Component } from 'react';
import { array, object, oneOfType } from 'prop-types';

import './StatisticsBar.scss';

class StatisticsBar extends Component {
  static propTypes = {
    children: oneOfType([array, object])
  };

  render() {
    return <div className="statistics__bar">{this.props.children}</div>;
  }
}

export default StatisticsBar;
